import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
// import { useHistory } from 'react-router-dom';
import doLogout from '../utils/auth/logout';
// reactstrap components
import { Container, Spinner } from 'reactstrap';
// core components
import AdminNavbar from '../components/Navbars/AdminNavbar.js';
import Sidebar from '../components/Sidebar/Sidebar.js';
import Header from '../components/Headers/Header.js';
//import { forEach, get, find, toNumber } from 'lodash-es';
import {
  useHostChargersListForMap,
  usePaginationCounts,
} from '../utils/queries/hostQueries.js';

import { useCustomerSessionsListForMap } from '../utils/queries/customerQueries';
import { useWhoAmI } from 'utils/queries/profileQueries';
import Dashboard from '../views/dashboard/Dashboard';
import Chargers from '../views/dashboard/Chargers';
import Analytics from '../views/dashboard/Analytics.js';
// import Earnings from '../views/dashboard/Earning';
import Profile from '../views/dashboard/Profile';
//import { differenceInSeconds } from 'date-fns';
import { useLocation } from 'react-router-dom';
import { match } from 'path-to-regexp';
import { routes, corporateAdminRoutes } from '../routes';
import ChargingSessions from 'views/dashboard/ChargingSessions.js';

const Admin = (props) => {
  const mainContent = React.useRef(null);

  const location = useLocation();
  // const history = useHistory();

  function HideHeaderOnChargerDetails() {
    const regexPattern = match('/admin/chargers/:cpid');
    return regexPattern(location.pathname);
  }

  function HideOnCustomerSessions() {
    const regexPattern = match('/admin/customerSessions');
    return regexPattern(location.pathname);
  }

  function HideOnProfile() {
    const regexPattern = match('/admin/myAccount');
    return regexPattern(location.pathname);
  }

  function HideOnAnalytics() {
    const regexPattern = match('/admin/analytics');
    return regexPattern(location.pathname);
  }

  function HideOnChargingSessions() {
    const regexPattern = match('/admin/sessions');
    return regexPattern(location.pathname);
  }

  function HideOnChargers() {
    const regexPattern = match('/admin/chargers');
    return regexPattern(location.pathname);
  }

  function hideOnDashboard() {
    const regexPattern = match('/admin/index');
    return regexPattern(location.pathname);
  }

  usePaginationCounts();

  const {
    data: accountInfo,
    isLoading: isLoadingProfile,
    error: errorProfile,
  } = useWhoAmI();

  const {
    data: chargers,
    isLoading,
    error,
  } = useHostChargersListForMap(accountInfo?.user?.IS_HOST);

  const {
    data: sessions,
    isLoading: isLoadingSessions,
    error: sessionsError,
  } = useCustomerSessionsListForMap();

  /* function getOnlineChargers() {
    let onlineChargers = 0;
    forEach(chargers, (charger, c) => {
      const { LAST_HEARTBEAT } = charger;
      let chargerConfig = {};
      if (get(charger, 'CHARGER_CONFIGURATION')) {
        chargerConfig = JSON.parse(get(charger, 'CHARGER_CONFIGURATION'));
      }

      const chargerHearBeatConfigObj = find(
        get(chargerConfig, 'configurationKey'),
        { key: 'HeartbeatInterval' },
      );
      const chargerHeartBeatInterval = toNumber(
        get(chargerHearBeatConfigObj, 'value'),
      );
      const diffInSeconds = differenceInSeconds(
        new Date(),
        new Date(LAST_HEARTBEAT),
      );

      if (diffInSeconds <= chargerHeartBeatInterval) {
        onlineChargers++;
      }
    });
    return onlineChargers;
  } */

  // const sendToLogin = () => {
  //   doLogout();
  //   history.push('/auth/login');
  // };

  if (error || sessionsError || errorProfile) {
    // sendToLogin();
    doLogout();
    window.location.reload();
    // history.push('/auth/login');
    return <div>Oops something went wrong...</div>;
  }

  const getRoutes = () =>
    accountInfo?.user?.IS_CORPORATE_ADMIN ? corporateAdminRoutes : routes;

  return (
    <>
      <Sidebar
        {...props}
        routes={getRoutes()}
        logo={{
          innerLink: '/admin/index',
          imgSrc: require('../assets/companyLogo/jplogo.png').default,
          imgAlt: '...',
        }}
      />

      <div
        className="main-content"
        ref={mainContent}
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        {isLoading || isLoadingSessions || isLoadingProfile ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              minHeight: '100vh',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spinner style={{ color: '#2675b8' }} />
          </div>
        ) : (
          <>
            <AdminNavbar accountInfo={accountInfo} brandText="Joulepoint" />
            {!HideHeaderOnChargerDetails() &&
            !HideOnCustomerSessions() &&
            !HideOnProfile() &&
            !HideOnAnalytics() &&
            !HideOnChargers() &&
            !HideOnChargingSessions() &&
            !hideOnDashboard() ? (
              <Header displayHostLabel={true} />
            ) : null}

            <Switch>
              {/* {getRoutes(routes)} */}
              <Route path="/admin/index" exact>
                <Dashboard chargers={chargers} sessions={sessions} />
              </Route>
              <Route path="/admin/myAccount" exact>
                <Profile accountInfo={accountInfo} />
              </Route>
              <Route path="/admin/chargers">
                <Chargers />
              </Route>
              <Route path="/admin/analytics" exact>
                <Analytics />
              </Route>
              <Route path="/admin/sessions" exact>
                <ChargingSessions />
              </Route>
              <Redirect from="*" to="/admin/index" />
            </Switch>
            <Container
              fluid
              style={{ marginTop: 'auto', height: '40px' }}
            ></Container>
          </>
        )}
      </div>
    </>
  );
};

export default Admin;
